// Import Dependencies
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import Locale JSON Translation Files
import enTranslations from "./locales/en/translations.json";
import hiTranslations from "./locales/hi/translations.json";
import mrTranslations from "./locales/mr/translations.json";
import gomTranslations from "./locales/gom/translations.json";
import arTranslations from "./locales/ar/translations.json";

// Local Imports
import { type LocaleCode, supportedLanguages } from "./langs";

// ----------------------------------------------------------------------

export const defaultLang: LocaleCode = "en";
export const fallbackLang: LocaleCode = "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enTranslations },
      hi: { translations: hiTranslations },
      mr: { translations: mrTranslations },
      gom: { translations: gomTranslations },
      ar: { translations: arTranslations },
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "l",
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",
    },
    fallbackLng: fallbackLang,
    lng: localStorage.getItem("i18nextLng") || defaultLang,
    supportedLngs: supportedLanguages,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
    lowerCaseLng: true,
    debug: false,
  });

i18n.languages = supportedLanguages;

export default i18n;
